/**
 * Adds a given data attribute to a card within a given query block.
 *
 * @param {string} queryClass Class name that identifies the query the card is in.
 * @param {string} dataAttribute Name of data attribute to add.
 */
const addContentCardDataAttributes = (queryClass, dataAttribute) => {
	const cards = document
		.querySelector(`.wp-block-bigbite-query.${queryClass}`)
		?.querySelectorAll('.wp-block-mavis-content-card');

	if (cards?.length > 0) {
		cards.forEach((card) => {
			const title = card.querySelector('h3');
			const anchor = card.querySelector('a');
			anchor.setAttribute(dataAttribute, title.innerText);
		});
	}
};

window.addEventListener('DOMContentLoaded', () => {
	if (!window.dataLayer) {
		return;
	}

	const { dataLayerData } = window;
	const { contentType, taxonomy, publishDate, tags } = dataLayerData;

	window.dataLayer.push({
		event: 'musedMetadata',
		contentType,
		taxonomy,
		tags,
		publishDate,
	});

	// Set 'data-ga-nav' attribute on relevant elements.
	const allCategoryNavElements = [
		...document.querySelectorAll('.wp-block-mavis-header-content li.menu-item-object-category a'),
	];
	const allPostTypeNavElements = [
		...document.querySelectorAll(
			'.wp-block-mavis-header-content nav li.menu-item-object-custom a, nav[aria-label="Content Types Menu"] li.menu-item-object-custom a',
		),
	];
	const mobileHeaderMoreBtn = document.querySelector(
		'.wp-block-mavis-header-content button.mavisHeader_menuToggle',
	);

	mobileHeaderMoreBtn.setAttribute('data-ga-nav', 'More button');
	allCategoryNavElements.forEach((el) => {
		el.setAttribute('data-ga-nav', 'Category visit');
	});
	allPostTypeNavElements.forEach((el) => {
		el.setAttribute('data-ga-nav', 'Format visit');
	});

	// Add data attributes to content cards in different locations.
	addContentCardDataAttributes('is-style-related-content', 'data-ga-ymal');
	addContentCardDataAttributes('is-style-latest', 'data-ga-latest');
});
